import { useContext } from 'react';

import PermissionsContext from './PermissionsContext';

const PermissionsAction = ({ children, id }) => {
  const { isActionAllowed } = useContext(PermissionsContext);
  const allowed = isActionAllowed(id);
  if (typeof children === 'function') {
    return children({
      isAllowed: allowed,
    });
  }

  return allowed ? children : null;
};

export default PermissionsAction;
